import { Injectable } from '@angular/core';
import { BaseApi } from '../../laas/base-api.service';
import { map } from 'rxjs/operators';

@Injectable()
export class SettingService {

  constructor(
    private api: BaseApi,
  ) { }

  changePassword(badWord) {
    return this.api.newPost(`/company/changeprd`, badWord).pipe(map(result => {
      return result;
    }))
  };

}
